import { MapSiteDataPreview } from './../../../../models/map-site-data-preview-model';
/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';
import { App, Project, SelectableField } from '../../../../models';

export class MapSiteDataPreviewFieldSelectionServiceModel {
    mapSiteDataPreviewForm: UntypedFormGroup;
    projectId: string;
    allFields: SelectableField[] = [];
    availableFields: SelectableField[] = [];
    selectedFields: SelectableField[] = [];
    previousApp: App;
    previousProject: Project;
    mapSiteDataPreview: MapSiteDataPreview;
    locationFieldIndex: number;
}
